import classNames from 'classnames';
import React, { useState } from 'react';
import * as styles from './SearchViewFilterMenu.module.scss';
import Button from '../components/Button';
import Caret from '../components/Caret';
import { MenuItem } from '../components/Menu';
import OverflowMenu from '../components/OverflowMenu';
import SVGIcon from '../components/SVGIcon';
import filterIcon from '../icons/non-prefilled/16x16/filter.svg';
import type { Facet } from '../topbar/quillFacets';
import {
  getDateFacet,
  MENTION_FACET,
  POST_STATE_FACET,
  TOPIC_FACET,
  USER_FACET,
} from '../topbar/quillFacets';
import { useAppendSearchBarFacet } from '../topbar/SearchBar';

const PUBLISHED_AFTER_FACET = getDateFacet('after', 'published');

type FilterMenuItem = {
  label: string;
  facet: Facet;
};

const filterMenuItems: FilterMenuItem[] = [
  {
    label: 'By author',
    facet: USER_FACET,
  },
  {
    label: 'By date',
    facet: PUBLISHED_AFTER_FACET,
  },
  {
    label: 'By mention',
    facet: MENTION_FACET,
  },
  {
    label: 'By status',
    facet: POST_STATE_FACET,
  },
  {
    label: 'By topic',
    facet: TOPIC_FACET,
  },
];

const SearchViewFilterMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const appendFacet = useAppendSearchBarFacet();

  return (
    <div className={styles.container}>
      <OverflowMenu
        onOpenChange={setIsOpen}
        open={isOpen}
        button={
          <Button
            className={classNames(styles.button, { [styles.open]: isOpen })}
          >
            <SVGIcon size={14}>{filterIcon}</SVGIcon>
            <div className={styles.label}>Filter results</div>
            <Caret direction={isOpen ? 'up' : 'down'} />
          </Button>
        }
      >
        {filterMenuItems.map(({ label, facet }) => (
          <MenuItem key={facet?.prefix} onClick={() => appendFacet(facet)}>
            {label}
          </MenuItem>
        ))}
      </OverflowMenu>
    </div>
  );
};

export default SearchViewFilterMenu;
